import { Box, ButtonGroup, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { ApiKey } from 'api';
import { CustomerSupportIconButton, GroupButtonItem } from 'components/index';
import { AppTypes } from 'enums';
import { appConfig } from 'forms/create-project/utils';
import { useAppBarHeight, useIsMobile, usePauseApp } from 'hooks';
import AppsSwitcher from 'pages/app-pages/components/AppsSwitcher';
import { Project } from 'types';

interface SchedulerTopBarProps {
  name: string;
}
const SchedulerTopBar = ({ name }: SchedulerTopBarProps) => {
  const appBarHeight = useAppBarHeight();
  const { isMobile } = useIsMobile();
  const { id } = useParams();
  const { data: project } = useSWR<Project>(`${ApiKey.Project}/${id}`);

  const app = project?.apps.find((a) => a.type === AppTypes.Messenger);

  const { togglePause, pausing } = usePauseApp({ project, appType: AppTypes.Messenger });

  return (
    <Stack
      bgcolor='messenger.dark'
      direction='row'
      alignItems='center'
      width={1}
      p={2}
      gap={2}
      color='messenger.contrastText'
      height={appBarHeight}
    >
      <Box flex={isMobile ? 'inherit' : 1}>
        <Stack
          direction='row'
          gap={1}
          alignItems='center'
          justifyContent='flex-start'
          overflow='hidden'
        >
          <AppsSwitcher currentApp={AppTypes.Messenger} />
          {!isMobile && (
            <Typography noWrap variant='subtitle2'>
              {appConfig[AppTypes.Messenger].label}
            </Typography>
          )}
        </Stack>
      </Box>
      <Stack
        direction='row'
        gap={1}
        alignItems={isMobile ? 'flex-start' : 'center'}
        overflow='hidden'
      >
        <Typography noWrap variant={isMobile ? 'subtitle2' : 'subtitle1'}>
          {name}
        </Typography>
      </Stack>
      <Stack justifyContent='flex-end' flex={1} direction='row' gap={2} alignItems='center'>
        <Stack direction='row' gap={2}>
          <CustomerSupportIconButton />
          {project?.token && (
            <ButtonGroup color='inherit' variant='outlined' size='small'>
              <GroupButtonItem
                iconColor={app?.isActive ? 'inherit' : 'grey.800'}
                tooltip={app?.isActive ? 'Deactivate Messenger' : 'Activate Messenger'}
                onClick={async () => {
                  await togglePause();
                }}
                icon='power_settings_new'
                loading={pausing}
              />
            </ButtonGroup>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SchedulerTopBar;
